import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { HttpClient } from '@angular/common/http';

import { AccountSettingsService } from '../../../../../app/main/pages/account-settings/account-settings.service';
import { CustomerService } from '../../../../../services/customer.service';

import Swal from 'sweetalert2';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { TemplateService } from "../../../../../services/template.service";


@Component({
  selector: 'app-template-sidebar',
  templateUrl: './template-sidebar.component.html'
})
export class TemplateSidebarComponent implements OnInit {

  @Input() currentTemplate;
  @Input() locations;
  @Output() newItemEvent = new EventEmitter<string>();

  public data: any;
  public loadingButton = false;

  public hasDeposit = false;
  public hasSetupFee = false;
  public hasAdminFee = false;

  
  public alertClose = true;
  public alert = "Error!";

  public practitionersList: any;

  public isSmallDisplay = true;

  public onboardContent: any;
  // private
  public today = new Date().toISOString().slice(0, 10);


  /**
   * Constructor
   *
   * @param {CoreSidebarService} _coreSidebarService
   */
  constructor(
    private _coreSidebarService: CoreSidebarService, 
    private _httpClient: HttpClient,
    private _customersService: CustomerService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private _templateService: TemplateService,
    private _accountSettingsService: AccountSettingsService) {
  }

  /**
   * Toggle the sidebar
   *
   * @param name
   */
  toggleSidebar(name): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
    this.addNewItem(this.currentTemplate);
    this.alertClose = true;
    this.currentTemplate =  {
      "id": null,
      "created_at": null,
      "location_id": [],
      "title": "",
      "description": "",
      "settings": {
        "limits": {
          "amount": {
            "max": 100000,
            "min": 10
          },
          "monthsLimit": 60,
          "onlyMembers": false
        },
        "editable": {
          "amount": true,
          "deposit": true,
          "adminFee": true,
          "setupFee": true,
          "start_at": true,
          "instalmentTimes": true
        },
              "frequency": {
        "weekly": true,
        "fortnightly": true,
        "monthly": true,
      }
      },
      "content": {
        "amount": null,
        "deposit": null,
        "adminFee": null,
        "setupFee": null,
        "start_at": null,
        "depositCash": true,
        "adminFeeCash": true,
        "setupFeeCash": true,
        "instalmentTimes": null,
        "paymentFrequency": "monthly"
      },
      "status": "active"
    }
  }

  switchDollarPercent(type) {
    switch (type) {
      case "setupFee":
        this.currentTemplate.content.setupFeeCash = !this.currentTemplate.content.setupFeeCash;
        break;

      case "deposit":
        this.currentTemplate.content.depositCash = !this.currentTemplate.content.depositCash;
        break;

      case "adminFee":
        this.currentTemplate.content.adminFeeCash = !this.currentTemplate.content.adminFeeCash;
        break;

      default:
        break;
    }
  }
          
  switchFrequency(type) {
    this.currentTemplate.settings.frequency[type] = !this.currentTemplate.settings.frequency[type]
  }   
  
  switchEditable(type){
    this.currentTemplate.settings.editable[type] = !this.currentTemplate.settings.editable[type]

  }
        

  /**
   * Submit
   *
   * @param form
   */
  submit(form, type) {
    if (form.valid) {
      this.loadingButton = true;
      switch (type) {
        case "new":
          this._templateService.createTemplate(this.currentTemplate).then(result => {
            this.loadingButton = false;
            this.toggleSidebar('template-sidebar');
          });          
          break;

        case "update":
          this._templateService.updateTemplate(this.currentTemplate).then(result => {
            this.loadingButton = false;
            this.toggleSidebar('template-sidebar');
          });   
          break;

      
        default:
          break;
      }

    }
  }

  selectAll() {    
    this.currentTemplate.location_id = this.locations.map(x => x.id);
  }  
  unselectAll() {
    this.currentTemplate.location_id = [];
  }  

  addNewItem(value: any) {
    this.newItemEvent.emit(value);
  }

  // modal Open Backdrop Disabled
  modalOpenBD(modalBD, size) {
    this.modalService.open(modalBD, {
      backdrop: true,
      centered: true,
      backdropClass: "dark-backdrop",
      size: size, // size: 'xs' | 'sm' | 'lg' | 'xl'
    });
  }

  // modal Open Discounts
  modalOpenDeleteItem(modalBD) {
    this.modalOpenBD(modalBD, "md");
  }

  deleteItem() {        
    this.loadingButton = false;
    this.modalService.dismissAll();
    this._templateService.updateTemplate({"id": this.currentTemplate.id,"status": "deleted"}).then((result) => {
       Swal.fire({
        title: "Done!",
        html:
          "<div><p>Template deleted.</p></div>",
          icon: "success",
        allowOutsideClick: true,
        showConfirmButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      }).then(()=> {
        this.loadingButton = false;
        this.toggleSidebar('template-sidebar');
      });
        

    })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error,
          showConfirmButton: true,
          allowOutsideClick: () => !Swal.isLoading(),
        });

      });
  }

  switchOption(type) {
    switch (type) {
      case "hasContentStartAt":
        this.currentTemplate.content.start_at = 0;
        this.currentTemplate.settings.editable.start_at = true;

        break;
      case "hasInstalmentTimes":
        this.currentTemplate.content.instalmentTimes = 1;
        this.currentTemplate.settings.editable.instalmentTimes = true;
        this.currentTemplate.settings.limits.monthsLimit = 60;
        break;
        

      case "hasAmount":
        this.currentTemplate.content.amount = 0;
        this.currentTemplate.settings.editable.amount = true;

        break;

      case "hasSetupFee":
        this.currentTemplate.content.setupFee = 0;
        this.currentTemplate.settings.editable.setupFee = true;
        this.currentTemplate.content.setupFeeCash = true;

        break;
      
      case "hasDeposit":
        this.currentTemplate.content.deposit = 0;
        this.currentTemplate.settings.editable.deposit = true;
        this.currentTemplate.content.depositCash = true;

        break;

      case "hasAdminFee":
        this.currentTemplate.content.adminFee = 0;
        this.currentTemplate.settings.editable.adminFee = true;
        this.currentTemplate.content.adminFeeCash = true;

        break;

      default:
        break;
    }
  }

  ngOnInit(): void {
    this.isSmallDisplay = window.screen.width < 1000;    
  };


}
